export default {
  countCells: 13,
  massive: [
    {
      dataField: 'region',
      cols: 1,
      rows: 1,
      text: 'ID',
      class: 'd-flex align-center  ',
      order: 0,
      variable: true,
      template: (r) => r?.id
    },
    {
      dataField: 'region1',
      cols: 10,
      rows: 1,
      text: 'Наименование',
      class: 'd-flex flex-row justify-space-between align-center',
      headerClass: '  ',
      styles: 'justify-content: unset;',
      headerStyles: `min-width: 510px;`,
      order: 0,
      variable: true,
      template: (r) => r?.name
    },
    {
      dataField: 'blocks',
      cols: 1,
      rows: 1,
      order: 2,
      variable: true,
      class: `justify-center`,
      headerStyles: `min-width: 44px;`,
      text: ``,
    },
    {
      dataField: 'actions',
      cols: 1,
      rows: 1,
      order: 3,
      variable: true,
      class: ``,
      headerStyles: `min-width:110px;`,
      text: ``,
    },
  ]
}
